/** Mirrors Documoto TOC chapter detection (see DocumotoTestReact `isTocChapterLikeNode`). */
export function isDocumotoChapterNode(nodeType: string): boolean {
	const t = String(nodeType).trim().toLowerCase();
	if (!t || t === 'page') {
		return false;
	}
	if (t === 'chapter' || t.includes('chapter')) {
		return true;
	}
	const branchTypes = new Set([
		'folder',
		'section',
		'group',
		'tocchapter',
		'book',
		'root',
		'container',
	]);
	return branchTypes.has(t);
}
